window.SoundPopup = (function () {
  var active = null;
  var wsInstances = {};

  function initWavePlayers(modal) {
    modal.querySelectorAll('.wave-player').forEach(function (el) {
      var audioUrl = el.dataset.audio;
      var index    = el.dataset.index;
      var waveEl   = document.getElementById('waveform-' + index);

      if (!audioUrl || !waveEl || wsInstances[index]) return;

      var ws = WaveSurfer.create({
        container:     waveEl,
        waveColor:     '#e6e3e3',
        progressColor: '#765837',
        height:        48,
        barWidth:      2,
        barRadius:     4,
        barGap:        1,
        url:           audioUrl
      });

      ws.on('play', function () {
        var btn = el.querySelector('.sound-modal__play');

        btn.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="5 5 14 14"><path fill="#fff" d="M15 19q-.825 0-1.412-.587T13 17V7q0-.825.588-1.412T15 5h2q.825 0 1.413.588T19 7v10q0 .825-.587 1.413T17 19zm-8 0q-.825 0-1.412-.587T5 17V7q0-.825.588-1.412T7 5h2q.825 0 1.413.588T11 7v10q0 .825-.587 1.413T9 19zm8-2h2V7h-2zm-8 0h2V7H7z"></path></svg>';
        btn.classList.add('is-playing');

        Object.keys(wsInstances).forEach(function (key) {
          if (key !== index) {
            try { wsInstances[key].pause(); } catch(e) {}

            var otherEl = document.querySelector('[data-index="' + key + '"]');

            if (otherEl) {
              var otherBtn = otherEl.querySelector('.sound-modal__play');

              if (otherBtn) {
                otherBtn.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="96 64 320 384"><path fill="#fff" d="m96 448l320-192L96 64z"></path></svg>';
                otherBtn.classList.remove('is-playing');
              }
            }
          }
        });
      });

      ws.on('pause', function () {
        var btn = el.querySelector('.sound-modal__play');

        if (btn) {
          btn.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="96 64 320 384"><path fill="#fff" d="m96 448l320-192L96 64z"></path></svg>';
          btn.classList.remove('is-playing');
        }
      });

      ws.on('finish', function () {
        var btn = el.querySelector('.sound-modal__play');

        if (btn) {
          btn.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="96 64 320 384"><path fill="#fff" d="m96 448l320-192L96 64z"></path></svg>';
          btn.classList.remove('is-playing');
        }
      });

      wsInstances[index] = ws;
    });
  }

  function open(productId) {
    close();

    var modal = document.getElementById('sound-modal-' + productId);

    if (!modal) return;

    modal.setAttribute('aria-modal', 'true');
    document.body.classList.add('sound-modal-open');

    active = modal;

    initWavePlayers(modal);

    var first = modal.querySelector('button');

    if (first) first.focus();
  }

  function close() {
    if (!active) return;

    Object.keys(wsInstances).forEach(function (key) {
      try { wsInstances[key].pause(); } catch(e) {}

      var el = document.querySelector('[data-index="' + key + '"]');

      if (el) {
        var btn = el.querySelector('.sound-modal__play');

        if (btn) {
          btn.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="96 64 320 384"><path fill="#fff" d="m96 448l320-192L96 64z"></path></svg>';
          btn.classList.remove('is-playing');
        }
      }
    });

    active.setAttribute('aria-modal', 'false');
    document.body.classList.remove('sound-modal-open');

    active = null;
  }

  function addSoundToCart(variantId, btn) {
    var originalText = btn.textContent;

    btn.textContent = '...';
    btn.disabled = true;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
      .then(function (res) {
        return res.json();
      })
      .then(function (data) {
        btn.textContent = '✓';

        setTimeout(function () {
          btn.textContent = originalText;
          btn.disabled = false;

          close();

          document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
            detail: { product: data }
          }));
        }, 800);
      })
      .catch(function () {
        btn.textContent = originalText;
        btn.disabled = false;
      });
  }

  function init() {
    document.addEventListener('click', function (e) {
      var trigger = e.target.closest('.sound-modal-trigger');

      if (trigger) {
        open(trigger.dataset.productId);
        return;
      }

      if (e.target.closest('.sound-modal__close')) {
        close();
        return;
      }

      if (active && !active.contains(e.target)) {
        close();
        return;
      }

      var playBtn = e.target.closest('.sound-modal__play');

      if (playBtn) {
        var el = playBtn.closest('.wave-player');

        if (el && wsInstances[el.dataset.index]) {
          wsInstances[el.dataset.index].playPause();
        }

        return;
      }

      var addBtn = e.target.closest('.sound-modal__add');

      if (addBtn) {
        addSoundToCart(addBtn.dataset.variantId, addBtn);
        return;
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') close();
    });

    document.addEventListener('dekstech:sounds-loaded', function (e) {
      if (e.detail && e.detail.modal) {
        initWavePlayers(e.detail.modal);
      }
    });
  }

  document.addEventListener('DOMContentLoaded', init);

  return {
    open: open,
    close: close
  };
})();